const FormatCurrency = (value: any) => {
  let val:any = Math.abs(value);
  
  if (val >= 1000 && val < 100000) {
    val = val.toFixed(2);
  }
  
  if (val >= 10000000) {
    val = (val / 10000000).toFixed(2) + ' Cr';
  }
  
  if (val >= 100000) {
    val = (val / 100000).toFixed(2) + ' L';
  }
  
  return val.toString();
};

export default FormatCurrency;